import {Field} from 'formik';
import {FormikTextInput} from '@shipwell/shipwell-ui';

const TriumphPayAuditFields = () => (
  <div className="mb-4 grid grid-cols-2 gap-4">
    <Field label="API Key" required name="tpa_api_key" component={FormikTextInput} />
    <Field label="Account Alias" required name="tpa_alias" component={FormikTextInput} />
  </div>
);

export default TriumphPayAuditFields;
